module.exports = __webpack_public_path__ + "static/media/kaga.97885ad1.png";